import {createContext, useState} from "react";


export const UserDetailContext = createContext({
    userDetail: null,
    updateUserDetail: () => {
    },
});


const UserDetailContextProvider = (props) => {
    const [userDetail, updateUserDetail] = useState({
        name: null,
        userId: null,
        email: null,
        mfaEnabled: true,
        active: false
    });

    const handleUpdateUserDetail = (serviceResponse) => {
        updateUserDetail((prevState) => {
            return ({
                ...prevState,
                name: serviceResponse.name,
                email: serviceResponse.email,
                userId: serviceResponse.userId,
                mfaEnabled: serviceResponse.mfaEnabled,
                active: serviceResponse.isActive
            })
        });
    }

    const initialState = {
        userDetail: userDetail,
        updateUserDetail: handleUpdateUserDetail,
    };

    return (
        <UserDetailContext.Provider value={initialState}>
            {props.children}
        </UserDetailContext.Provider>
    )
}

export default UserDetailContextProvider;